import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import {injectIntl} from 'react-intl';
import messages from '../../../../../../res/translations/messages';
import QuestionIdComposed from '../QuestionIdComposed';
import Operator from '../Operator';
import Value from '../Value';

class MultipleNumberBuilder extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {expression, intl} = this.props;

        let operator;
        switch (expression.condition.operator) {
            case constants.EDITOR_OPERATORS.LT:
                operator = intl.formatMessage({...messages.filters.operators.lessThan});
                break;
            case constants.EDITOR_OPERATORS.GT:
                operator = intl.formatMessage({...messages.filters.operators.greaterThan});
                break;
            case constants.EDITOR_OPERATORS.EQ:
                operator = intl.formatMessage({...messages.filters.operators.equal});
                break;
        }

        if (!operator) {
            return null;
        }

        return (
            <>
                <QuestionIdComposed questionId={expression.id} optionId={expression.condition.question} />
                <Operator operator={operator} />
                <Value value={expression.condition.value} />
            </>
        );
    }
}

export default injectIntl(MultipleNumberBuilder);
